import React from "react";

const ServiceMenu = ({ navbarHeight = 90, className = "", links = [] }) => {
  const handleLinkClick = (e, anchor) => {
    e.preventDefault();

    const targetElement = document.querySelector(anchor);
    if (!targetElement) return;

    // Calculate position manually for more control
    const elementTop = targetElement.offsetTop;
    const navbarHeight = 90;

    window.scrollTo({
      top: elementTop,
    });
  };

  return (
    <div className={`w-full ${className}`}>
      <div className="px-8 pb-12 sm:pt-0 sm:pb-3 lg:px-12">
        <nav className="flex flex-col sm:flex-row sm:flex-wrap justify-start gap-0 sm:gap-6 lg:gap-8 border-t border-[var(--color-primary)] sm:border-0">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.anchor}
              onClick={(e) => handleLinkClick(e, link.anchor)}
              className="text-lg font-medium text-[var(--color-primary)]  transition-colors duration-200 border-b border-[var(--color-primary)] py-3 sm:border-0 sm:border-b-2 sm:border-transparent sm:hover:border-gray-900 sm:py-0 sm:pb-1 pl-0 text-left w-full sm:w-auto"
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default ServiceMenu;
